var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_520_1561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0632 0H9.33398H4.66732H3.93815C3.05323 0 2.33398 0.770625 2.33398 1.71875V13.2812C2.33398 14.2294 3.05323 15 3.93815 15H10.0632C10.9481 15 11.6673 14.2294 11.6673 13.2812V1.71875C11.6673 0.770625 10.9481 0 10.0632 0ZM10.5007 13.125C10.5007 13.47 10.2393 13.75 9.91732 13.75H4.08398C3.76198 13.75 3.50065 13.47 3.50065 13.125V1.875C3.50065 1.53 3.76198 1.25 4.08398 1.25H4.37565C4.69765 1.25 4.95898 1.53 4.95898 1.875C4.95898 2.22 5.22032 2.5 5.54232 2.5H8.45898C8.78098 2.5 9.04232 2.22 9.04232 1.875C9.04232 1.53 9.30365 1.25 9.62565 1.25H9.91732C10.2393 1.25 10.5007 1.53 10.5007 1.875V13.125Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_520_1561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogin);
export default __webpack_public_path__ + "static/media/mobile-login.bbea6249e98022c6670999900efc2100.svg";
export { ForwardRef as ReactComponent };